export default [
  {
    path: '/:catchAll(.*)',
    redirect: '/',
  },
];
